import { Dropdown } from "antd";
import type { MenuProps } from "antd";
import DownArrow from "../../../assets/DownArrow";
import {
  AdminIcon,
  BillingIcon,
  CustomerIcon,
  LogoutIcon,
  ReportIcon,
  SupportIcon,
} from "../../../assets/profileDropdown";
import { Link } from "react-router-dom";

const iconRenderer = (iconName: string) => {
  switch (iconName) {
    case "AdminIcon":
      return <AdminIcon />;
    case "BillingIcon":
      return <BillingIcon />;
    case "LogoutIcon":
      return <LogoutIcon />;
    case "ReportIcon":
      return <ReportIcon />;
    case "SupportIcon":
      return <SupportIcon />;
    default:
      return null; // Return null or a default icon if no match is found
  }
};

const dropDownItems = [
  { label: "Admin", icon: "AdminIcon", path: 'mailto:support@dantaniinc.com' },
  { label: "Billing & Invoices", icon: "BillingIcon" ,path: 'mailto:support@dantaniinc.com' },
  { label: "Customise Report", icon: "ReportIcon" },
  { label: "Support", icon: "SupportIcon" ,path: 'mailto:support@dantaniinc.com' },
  { label: "Logout", icon: "LogoutIcon", path: '/logout' },
];

const items: MenuProps["items"] = dropDownItems?.map((item, index) => {
  const isExternalLink = ["AdminIcon", "BillingIcon", "SupportIcon"].includes(item?.icon);

  return {
    key: `${item.icon + index}`,
    label: (
      <div className="w-full border-b border-[#EBEBEB] text-sm p-3 pl-4 mr-3 ">
        {isExternalLink ? (
          <a href={item.path} target="_blank" rel="noopener noreferrer">
            <div className="flex items-center gap-2 ">
              <div className="w-[10%] flex justify-center">
                {iconRenderer(item?.icon)}
              </div>
              <span className="text-[#404040] ">{item?.label}</span>
            </div>
          </a>
        ) : (
          <Link to={item?.path ? item?.path : '#'}>
            <div className="flex items-center gap-2 ">
              <div className="w-[10%] flex justify-center">
                {iconRenderer(item?.icon)}
              </div>
              <span className="text-[#404040] ">{item?.label}</span>
            </div>
          </Link>
        )}
      </div>
    ),
  };
});

export default function SidebarProfile() {
  const user = localStorage.getItem('user');
  const userData = JSON.parse(user || '{}');

  return (
    <div className="flex w-full items-center gap-5 font-poppins">
      <div>
        <CustomerIcon />
      </div>

      <div className="md:flex sm:flex hidden flex-col items-start gap-0.5">
        <span className="text-sm font-bold text-black">{userData?.first_name} {userData?.last_name}</span>
        <span className="text-xm  text-black">{userData?.companies_name} </span>
      </div>

      <Dropdown
        menu={{ items }}
        trigger={["click"]}
        overlayClassName="sidebarProfileDropDown"
      >
        <div className="md:flex sm:flex hidden cursor-pointer active:opacity-50">
          <DownArrow />
        </div>
      </Dropdown>
      <style>{`
      .sidebarProfileDropDown .ant-dropdown-menu {
        padding: 0px !important;
      }
      .sidebarProfileDropDown .ant-dropdown-menu-item {
        padding: 0px !important;
      }
      `}</style>
    </div>
  );
}
